import { render } from "./ArticleFeatureText.vue?vue&type=template&id=d3ba9672&scoped=true"
import script from "./ArticleFeatureText.vue?vue&type=script&lang=js"
export * from "./ArticleFeatureText.vue?vue&type=script&lang=js"

import "./ArticleFeatureText.vue?vue&type=style&index=0&id=d3ba9672&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ba9672"]])

export default __exports__